import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsHideIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M316 679.333l-60-60 256-256 256 256-60 60-196-196z" />
    </g>
  </StyledIcon>
)

CsHideIcon.displayName = 'CsHideIcon'
